export const formatSnakeCaseToReadableString = (snakeString: string) => {
    const readableString = snakeString.replace(/_/g, " ").toLowerCase()
    return readableString.charAt(0).toUpperCase() + readableString.substring(1)
}
